import find from "lodash/find";
import { ProfileEditPage } from "PFApp/profiles/edit/profile_edit_page";
import { profileEditSections } from "PFApp/profiles/edit/profile_edit_sections";
import { useAppShellStoreActions } from "PFApp/stores/app_shell_store";
import api from "PFCore/api";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { FeatureFlag } from "PFTypes";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

const ProfileEditController = () => {
  const navigate = useNavigate();

  const isEnabled = useIsFeatureEnabled();
  const { data: currentProfile } = useCurrentProfile();
  const { showTerms } = useAppShellStoreActions();

  let { section = isEnabled(FeatureFlag.PasswordSignin) ? "credentials" : "notifications" } = useParams();

  if (section === "suggested_skills") {
    section = "credentials";
  }

  useEffect(() => {
    const sectionComponent = find(profileEditSections(showTerms), { section });

    if (
      !sectionComponent ||
      (sectionComponent.requireFeature && !isEnabled(sectionComponent.requireFeature)) ||
      (sectionComponent.isVisible && !sectionComponent.isVisible())
    ) {
      navigate("/profile/edit");
      return null;
    }
  }, [section]);

  const id = currentProfile?.id;

  const [profile, setProfile] = useState({});

  useEffect(() => {
    setProfile(currentProfile);
  }, [currentProfile]);

  const handleProfileUpdate = (attributes = {}) => {
    const isMe = id === "me" || id === currentProfile.id;
    const url = isMe ? "me" : `profiles/${id}`;
    const noUpdate = Object.keys(attributes).length === 0;

    return api({
      url,
      method: noUpdate ? "GET" : "PUT",
      data: noUpdate ? null : attributes
    }).then((resp) => setProfile(resp));
  };

  return (
    <ProfileEditPage
      profile={profile}
      sections={profileEditSections(showTerms)}
      section={section}
      permissionsGroup={currentProfile.permissionsGroup}
      handleProfileUpdate={handleProfileUpdate}
    />
  );
};

export default ProfileEditController;
